module.exports = __webpack_public_path__ + "static/media/Metronome.49392b67.mp3";